import { useCart } from '../../context/CartContext';
import { formatCurrency } from '../../utils/formatting';
import { XMarkIcon, PlusIcon, MinusIcon } from '@heroicons/react/24/solid';

export default function CartItem({ item }) {
  const { removeFromCart, updateQuantity } = useCart();

  // Use the correct properties from the campaign object
  const productName = item.product_name || 'Unnamed Product';
  const recipientName = item.type === 'organization' 
    ? item.organization_name 
    : `${item.first_name || ''} ${item.last_name || ''}`.trim() || 'A Recipient';
  const imageUrl = item.product_image_url || `https://via.placeholder.com/150?text=${productName.replace(' ', '+')}`;
  const price = item.product_price || 0;
  const quantity = item.quantity || 1;
  const totalPrice = item.totalPrice || price * quantity;

  const handleIncrement = () => {
    updateQuantity(item.id, quantity + 1);
  };

  const handleDecrement = () => {
    if (quantity > 1) {
      updateQuantity(item.id, quantity - 1);
    }
  };

  return (
    <div className="flex items-center gap-4 p-4 border-b border-gray-200 dark:border-gray-700">
      <img src={imageUrl} alt={productName} className="w-24 h-24 object-cover rounded-md" />
      
      <div className="flex-grow">
        <h3 className="text-lg font-bold text-gray-800 dark:text-white">{productName}</h3>
        <p className="text-sm text-gray-500 dark:text-gray-400">For: {recipientName}</p>
        
        {/* Quantity controls for organization campaigns */}
        {item.type === 'organization' && (
          <div className="flex items-center mt-2">
            <button 
              onClick={handleDecrement}
              disabled={quantity <= 1}
              className="p-1 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
            >
              <MinusIcon className="w-4 h-4" />
            </button>
            
            <span className="mx-3 font-semibold">{quantity}</span>
            
            <button 
              onClick={handleIncrement}
              className="p-1 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600"
            >
              <PlusIcon className="w-4 h-4" />
            </button>
          </div>
        )}
        
        <p className="text-lg font-semibold text-orange-500 dark:text-orange-400 mt-2">
          {formatCurrency(totalPrice)}
          {quantity > 1 && (
            <span className="text-sm text-gray-500 ml-2">
              ({formatCurrency(price)} × {quantity})
            </span>
          )}
        </p>
      </div>
      
      <button 
        onClick={() => removeFromCart(item.id)}
        className="p-2 text-gray-400 hover:text-red-500 dark:hover:text-red-400 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        title="Remove item"
      >
        <XMarkIcon className="w-6 h-6" />
      </button>
    </div>
  );
}